export default "__VITE_ASSET__0018d707__"